import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ExportContext } from '../../../../provider/ExportProvider';

export default function FormCompanyDelete() {
  const { setModal, setInvoice, getInvoice, deleteCompanies } =
    useContext(ExportContext)!.controllers.company;

  const [loading, setLoading] = useState(false);

  const selectedCompany = getInvoice('selected.company');
  const selectedCompanies = getInvoice('selecteds.companies');
  const companyIds =
    selectedCompany !== -1 ? [selectedCompany] : selectedCompanies;
  const length = companyIds.length;

  const close = () => {
    setModal('single.deleteCompanies', false);
    setInvoice('selected.company', -1);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    deleteCompanies(companyIds)
      .then(() => {
        close();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '30vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <div style={{ marginLeft: '20px' }}>
          {length === 1
            ? 'Tem certeza que deseja excluir a companhia?'
            : `Tem certeza que deseja excluir ${length} companhias?`}
        </div>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={close}>
          Fechar
        </Form.Button>
        <Form.Button loading={loading}>Excluir</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
